"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RuleItem = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

const StyledActionItem = (0, _styledComponents.default)(_blocks.ActionItemButton)`
  display: inline-flex;
  ${_blocks.ArrowChevronRight} {
    visibility: hidden;
  }
  &:hover {
    ${_blocks.ArrowChevronRight} {
      visibility: visible;
    }
  }
`;
const RuleText = _styledComponents.default.span`
  margin-left: ${_blocks.spacing.tight};
`;
const Item = _styledComponents.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  label {
    margin-bottom: 0;
  }
`;
const RuleItem = /*#__PURE__*/React.memo(({
  isActive,
  rule,
  onRuleSelect,
  onRuleChecked,
  isChecked
}) => {
  return /*#__PURE__*/React.createElement(StyledActionItem, {
    isActive: isActive,
    iconRight: /*#__PURE__*/React.createElement(_blocks.ArrowChevronRight, {
      tiny: true
    }),
    onClick: () => onRuleSelect(rule)
  }, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(_blocks.Checkbox, {
    name: "RuleCheckbox",
    value: "",
    checked: isChecked,
    onChange: onRuleChecked(rule)
  }), /*#__PURE__*/React.createElement(RuleText, null, rule.rule.name)));
}, (p, n) => p.isChecked === n.isChecked && p.isActive === n.isActive);
exports.RuleItem = RuleItem;